export interface PropertyLocation {
  lat: number;
  lng: number;
  streetAddress?: string;
  locality?: string;
}

// Owner-confirmed shared address, 13 September 2026. Esri's address geocoder
// resolves Ylläksentie 1428, Kittilä to this street-address position (WGS84).
// These are site coordinates, not separate building entrances.
export const YLLAS_LOCATION: PropertyLocation = {
  lat: 67.5762104,
  lng: 24.4754732,
  streetAddress: 'Ylläksentie 1428',
  locality: 'Kittilä',
};

// Shared by every public cabin map and VacationRental structured data.
export const propertyLocations: Record<string, PropertyLocation | undefined> = {
  'skycabin-levi': { lat: 67.7956, lng: 24.813 },
  'levikka-yllas': YLLAS_LOCATION,
  'varakka-yllas': YLLAS_LOCATION,
  pikupoikka: YLLAS_LOCATION,
  isopoikka: YLLAS_LOCATION,
  mestari: YLLAS_LOCATION,
  'aijakka-yllas': YLLAS_LOCATION,
  'iso-yllas': YLLAS_LOCATION,
};

export function locationAddress(location: PropertyLocation) {
  return [location.streetAddress, location.locality].filter(Boolean).join(', ');
}

export function locationMapUrl(location: PropertyLocation) {
  const query = location.streetAddress
    ? `${locationAddress(location)}, Finland`
    : `${location.lat},${location.lng}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function resortName(resort: string) {
  return resort === 'levi' ? 'Levi' : resort === 'yllas' ? 'Ylläs' : 'Lapland';
}
